import Modal from "@material-tailwind/react/Modal";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import React from "react";
import DynamicTable from "../tablecard/DynamicTable";

export default function HrdReportModal(props) {
    let header = [];
    switch (props.type) {
        case "sakit":
            header = [
                {name: "Jenis Penyakit", key: "JenisPenyakit", modifiers: "Text"},
                {name: "Jenis Perawatan", key: "JenisPerawatan", modifiers: "Text"},
                {name: "Jumlah Hari Kerja", key: "JumlahHariKerja", modifiers: "number"},
                {name: "Jumlah HariSakit", key: "JumlahHariSakit", modifiers: "number"},
                {name: "Tanggal Sakit", key: "TanggalSakit", modifiers: "Date"},
                {name: "Tanggal Sembuh", key: "TanggalSembuh", modifiers: "Date"},
            ]
            break;
        case "lembur":
            header = [
                {name: "Keperluan Lembur", key: "KeperluanLembur", modifiers: "Text"},
                {name: "Mulai Lembur", key: "MulaiLembur", modifiers: "Text"},
                {name: "Selesai Lembur", key: "SelesaiLembur", modifiers: "Text"},
                {name: "Tanggal Lembur", key: "TanggalLembur", modifiers: "Text"},
                {name: "Total Jam", key: "TotalJam", modifiers: "Text"},
                // Sama seperti kolom "Akumulasi Durasi" di list report/lembur — jam
                // ekivalen PP35 (TLembur.FaktorLembur), kosong utk dokumen sebelum PP35.
                {name: "Akumulasi Durasi", key: "AkumulasiDurasiLabel", modifiers: "Text"},
            ]
            break;
        case "claim":
            header = [
                {name: "Tanggal Sakit", key: "TglMasuk", modifiers: "Date"},
                {name: "Rumah Sakit", key: "RumahSakit", modifiers: "Text"},
                {name: "Jenis Rawat", key: "JenisRawat", modifiers: "JenisRawat"},
                {name: "Nama Dokter", key: "NamaDokter", modifiers: "Text"},
                {name: "Nama Obat", key: "NamaObat", modifiers: "Text"},
                {name: "Biaya Obat", key: "BiayaObat", modifiers: "Number"},

                {name: "Total Biaya", key: "TotalBiaya", modifiers: "Number"},
            ]
            break;
        case "cuti":
            header = [
                {name: "Keperluan Cuti", key: "KeperluanCuti", modifiers: "Text"},
                {name: "Tanggal Mulai", key: "TanggalMulai", modifiers: "Date"},
                {name: "Tanggal Akhir", key: "TanggalAkhir", modifiers: "Date"},
                {name: "Saldo Cuti", key: "SaldoCuti", modifiers: "Number"},
                {name: "Jumlah Cuti", key: "JumlahCuti", modifiers: "Number"},
                {name: "Saldo Akhir", key: "SaldoAkhir", modifiers: "Number"},
            ]
            break;
    }
    let details = []
    if (props.detail.Detail) {
        details = props.detail.Detail
    }
    if (props.type === "lembur") {
        details = details.map((d) => ({
            ...d,
            AkumulasiDurasiLabel: d.AkumulasiDurasi ? `${d.AkumulasiDurasi} jam` : "-",
        }));
    }

    // Buka/unduh lampiran "Data Pendukung" (mis. lembur). File di-serve via /file/<NamaFile>.
    const downloadLampiran = () => {
        const namaFile = props.detail && props.detail.NamaFile;
        if (!namaFile) {
            alert("Tidak ada file lampiran");
            return;
        }
        const fileUrl =
            (process.env.REACT_APP_API_UPLOAD_URL || "/") +
            "file/" +
            encodeURIComponent(namaFile);
        fetch(fileUrl, {method: "GET", headers: {Accept: "application/octet-stream"}})
            .then((r) => {
                if (!r.ok) throw new Error("HTTP " + r.status);
                return r.blob();
            })
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                if (blob.type.includes("pdf") || blob.type.includes("image")) {
                    window.open(url, "_blank");
                } else {
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = namaFile;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }
            })
            .catch((e) => alert("Gagal membuka lampiran: " + e.message));
    };

    return (
        <Modal
            size="lg"
            active={props.showModal}
            toggler={() => {
                props.setShowModal(true);
            }}
        >
            <ModalHeader
                className="mt-20"
                toggler={() => {
                    props.setShowModal(false);
                }}
            >
                Detail {props.Name}
            </ModalHeader>
            <ModalBody>
                <div className={"w-max"}>
                    <div className="flex flex-row flex-wrap items-start justify-start w-max px-2 py-2">
                        <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Nik</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={props.detail.Nik}
                            />
                        </div>
                        <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Jabatan</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={props.detail.Jabatan}

                            />
                        </div>
                    </div>
                    <div className="flex flex-row flex-wrap items-start justify-start w-max px-2 py-2">
                        <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Nama</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={props.detail.NamaKaryawan}

                            />
                        </div>
                        <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Status
                                Karyawan</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={props.detail.Golongan}

                            />
                        </div>
                    </div>
                    <div className="flex flex-row flex-wrap items-start justify-start w-max px-2 py-2">
                        <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">TMK</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={new Date(props.detail.TglMasuk).toLocaleDateString("ID")}

                            />
                        </div>
                        {props.type === "cuti" && <div className={"px-2"}>
                            <label htmlFor="first_name"
                                   className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">Hak
                                Cuti</label>
                            <input type="text" id="first_name"
                                   className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 "
                                   disabled={true}
                                   value={props.detail.HakCuti}

                            />
                        </div>}
                    </div>
                    {props.type === "lembur" && (
                        <div className="px-2 py-2">
                            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                                Data Pendukung
                            </label>
                            {props.detail && props.detail.NamaFile ? (
                                <button
                                    type="button"
                                    onClick={downloadLampiran}
                                    className="flex flex-row items-center gap-2 text-white bg-main-100 hover:opacity-90 font-medium rounded-lg text-sm px-4 py-2"
                                >
                                    Lihat Lampiran
                                </button>
                            ) : (
                                <span className="text-sm text-gray-400 italic">
                                    Tidak ada lampiran
                                </span>
                            )}
                        </div>
                    )}
                    <div className={"mt-2"}>
                        <DynamicTable withoutAttribut={true} header={header} data={details}/>

                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="red"
                    buttonType="link"
                    onClick={() => {
                        props.setShowModal(false);
                    }}
                    ripple="dark"
                >
                    Close
                </Button>

            </ModalFooter>
        </Modal>

    )
}